import { render, staticRenderFns } from "./HowWorks.vue?vue&type=template&id=9bd5f606&scoped=true"
import script from "./HowWorks.vue?vue&type=script&lang=js"
export * from "./HowWorks.vue?vue&type=script&lang=js"
import style0 from "./HowWorks.vue?vue&type=style&index=0&id=9bd5f606&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd5f606",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VImg,VList,VListItem,VListItemContent,VListItemIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/Users/afonsomonteiro/onboarding/onboarding/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bd5f606')) {
      api.createRecord('9bd5f606', component.options)
    } else {
      api.reload('9bd5f606', component.options)
    }
    module.hot.accept("./HowWorks.vue?vue&type=template&id=9bd5f606&scoped=true", function () {
      api.rerender('9bd5f606', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lp/HowWorks.vue"
export default component.exports